import { useNavigate } from 'react-router-dom';

export default function GuidelinesPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
      {/* Header */}
      <header className="border-b border-slate-700 py-4 px-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-slate-300 hover:text-white transition-colors"
          >
            <span>←</span>
            <span>홈으로</span>
          </button>
          <h1 className="text-lg font-semibold">커뮤니티 가이드라인</h1>
          <div className="w-20" />
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-8">
        {/* Title */}
        <div className="text-center mb-8">
          <div className="text-4xl mb-4">📜</div>
          <h2 className="text-2xl font-bold mb-2">커뮤니티 가이드라인</h2>
          <p className="text-slate-400">건전하고 즐거운 토론 문화를 위한 규칙</p>
          <p className="text-slate-500 text-sm mt-2">최종 수정일: 2024년 9월</p>
        </div>

        {/* Introduction */}
        <section className="bg-slate-800/50 rounded-2xl p-6 mb-6">
          <h3 className="text-xl font-semibold mb-4">🎯 가이드라인 목적</h3>
          <p className="text-slate-300 leading-relaxed">
            말싸움은 다양한 의견이 자유롭게 오가는 토론 플랫폼입니다. 
            모든 사용자가 안전하고 즐겁게 토론에 참여할 수 있도록, 
            아래의 커뮤니티 가이드라인을 준수해 주시기 바랍니다.
            이 가이드라인을 위반할 경우 경고, 일시 정지, 영구 정지 등의 조치가 취해질 수 있습니다.
          </p>
        </section>

        {/* Core Values */}
        <section className="bg-slate-800/50 rounded-2xl p-6 mb-6">
          <h3 className="text-xl font-semibold mb-4">💎 핵심 가치</h3>
          <div className="grid md:grid-cols-3 gap-4">
            <div className="bg-slate-700/50 rounded-xl p-4 text-center">
              <div className="text-2xl mb-2">🤝</div>
              <h4 className="font-medium mb-1">상호 존중</h4>
              <p className="text-sm text-slate-400">의견이 달라도 상대를 존중합니다</p>
            </div>
            <div className="bg-slate-700/50 rounded-xl p-4 text-center">
              <div className="text-2xl mb-2">⚖️</div>
              <h4 className="font-medium mb-1">공정한 토론</h4>
              <p className="text-sm text-slate-400">논리와 근거로 승부합니다</p>
            </div>
            <div className="bg-slate-700/50 rounded-xl p-4 text-center">
              <div className="text-2xl mb-2">🌈</div>
              <h4 className="font-medium mb-1">다양성 존중</h4>
              <p className="text-sm text-slate-400">모든 배경의 사람을 환영합니다</p>
            </div>
          </div>
        </section>

        {/* Prohibited Actions */}
        <section className="bg-red-900/20 border border-red-800/50 rounded-2xl p-6 mb-6">
          <h3 className="text-xl font-semibold mb-4 text-red-400">🚫 금지 행위</h3>
          
          <div className="space-y-4">
            <div>
              <h4 className="font-medium mb-2 flex items-center gap-2">
                <span className="text-red-400">1.</span> 욕설 및 인신공격
              </h4>
              <p className="text-slate-400 text-sm pl-5">
                상대방에 대한 욕설, 비속어, 모욕적인 표현은 금지됩니다. 
                토론 주제가 아닌 상대방 개인을 공격하는 행위도 포함됩니다.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium mb-2 flex items-center gap-2">
                <span className="text-red-400">2.</span> 혐오 발언
              </h4>
              <p className="text-slate-400 text-sm pl-5">
                인종, 민족, 국적, 성별, 성적 지향, 종교, 장애, 질병 등을 이유로 
                특정 개인이나 집단을 비하, 차별, 혐오하는 발언은 금지됩니다.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium mb-2 flex items-center gap-2">
                <span className="text-red-400">3.</span> 성적 발언 및 성희롱
              </h4>
              <p className="text-slate-400 text-sm pl-5">
                성적으로 부적절한 발언, 성희롱, 음란한 내용의 발언은 금지됩니다.
                상대방이 불쾌감을 느낄 수 있는 성적 농담도 포함됩니다.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium mb-2 flex items-center gap-2">
                <span className="text-red-400">4.</span> 불법 행위 조장
              </h4>
              <p className="text-slate-400 text-sm pl-5">
                마약, 도박, 사기, 폭력, 테러 등 불법 행위를 조장하거나 
                관련 정보를 공유하는 것은 금지됩니다.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium mb-2 flex items-center gap-2">
                <span className="text-red-400">5.</span> 개인정보 노출
              </h4>
              <p className="text-slate-400 text-sm pl-5">
                다른 사용자의 동의 없이 실명, 주소, 전화번호, 사진 등 
                개인정보를 공개하는 것은 금지됩니다.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium mb-2 flex items-center gap-2">
                <span className="text-red-400">6.</span> 게임 방해
              </h4>
              <p className="text-slate-400 text-sm pl-5">
                의도적으로 게임을 방해하거나, 발언 시간을 독점하거나, 
                무의미한 소리를 반복하는 등의 행위는 금지됩니다.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium mb-2 flex items-center gap-2">
                <span className="text-red-400">7.</span> 허위 정보 유포
              </h4>
              <p className="text-slate-400 text-sm pl-5">
                의도적으로 거짓 정보를 사실인 것처럼 주장하거나, 
                출처가 불분명한 정보를 사실로 단정짓는 것은 지양해 주세요.
              </p>
            </div>
            
            <div>
              <h4 className="font-medium mb-2 flex items-center gap-2">
                <span className="text-red-400">8.</span> 스팸 및 광고
              </h4>
              <p className="text-slate-400 text-sm pl-5">
                토론과 무관한 광고, 홍보, 스팸 링크 공유는 금지됩니다.
              </p>
            </div>
          </div>
        </section>

        {/* Recommended Behavior */}
        <section className="bg-green-900/20 border border-green-800/50 rounded-2xl p-6 mb-6">
          <h3 className="text-xl font-semibold mb-4 text-green-400">✅ 권장 행동</h3>
          
          <div className="space-y-3 text-slate-300">
            <div className="flex gap-3">
              <span className="text-green-400">•</span>
              <span>상대방의 발언을 끝까지 경청하고, 차분하게 반론하세요.</span>
            </div>
            <div className="flex gap-3">
              <span className="text-green-400">•</span>
              <span>논리와 근거를 바탕으로 설득력 있게 주장하세요.</span>
            </div>
            <div className="flex gap-3">
              <span className="text-green-400">•</span>
              <span>상대의 좋은 논점은 인정하고, 배울 점은 배우세요.</span>
            </div>
            <div className="flex gap-3">
              <span className="text-green-400">•</span>
              <span>승패와 관계없이 좋은 토론을 나눈 상대에게 칭찬을 보내세요.</span>
            </div>
            <div className="flex gap-3">
              <span className="text-green-400">•</span>
              <span>명확하고 또렷한 발음으로 말하세요.</span>
            </div>
            <div className="flex gap-3">
              <span className="text-green-400">•</span>
              <span>배심원으로 참여할 때는 공정하게 판단하세요.</span>
            </div>
          </div>
        </section>

        {/* Penalties */}
        <section className="bg-slate-800/50 rounded-2xl p-6 mb-6">
          <h3 className="text-xl font-semibold mb-4">⚠️ 제재 조치</h3>
          
          <p className="text-slate-400 mb-4">
            가이드라인 위반 시 위반의 심각성과 반복 여부에 따라 다음과 같은 조치가 취해집니다:
          </p>
          
          <div className="space-y-3">
            <div className="flex items-center gap-4 bg-slate-700/30 rounded-lg p-3">
              <div className="w-24 text-center">
                <span className="text-yellow-400 font-medium">1단계</span>
              </div>
              <div className="flex-1">
                <span className="font-medium">경고</span>
                <p className="text-sm text-slate-400">경미한 1회 위반 시</p>
              </div>
            </div>
            
            <div className="flex items-center gap-4 bg-slate-700/30 rounded-lg p-3">
              <div className="w-24 text-center">
                <span className="text-orange-400 font-medium">2단계</span>
              </div>
              <div className="flex-1">
                <span className="font-medium">1일~7일 정지</span>
                <p className="text-sm text-slate-400">반복 위반 또는 중간 정도의 위반 시</p>
              </div>
            </div>
            
            <div className="flex items-center gap-4 bg-slate-700/30 rounded-lg p-3">
              <div className="w-24 text-center">
                <span className="text-red-400 font-medium">3단계</span>
              </div>
              <div className="flex-1">
                <span className="font-medium">7일~30일 정지</span>
                <p className="text-sm text-slate-400">심각한 위반 또는 다수의 반복 위반 시</p>
              </div>
            </div>
            
            <div className="flex items-center gap-4 bg-slate-700/30 rounded-lg p-3">
              <div className="w-24 text-center">
                <span className="text-red-600 font-medium">4단계</span>
              </div>
              <div className="flex-1">
                <span className="font-medium">영구 정지</span>
                <p className="text-sm text-slate-400">매우 심각한 위반 또는 지속적인 위반 시</p>
              </div>
            </div>
          </div>
          
          <p className="text-slate-500 text-sm mt-4">
            * 혐오 발언, 성희롱, 불법 행위 조장 등 심각한 위반은 1회에도 즉시 영구 정지될 수 있습니다.
          </p>
        </section>

        {/* Reporting */}
        <section className="bg-slate-800/50 rounded-2xl p-6 mb-6">
          <h3 className="text-xl font-semibold mb-4">🚨 신고 방법</h3>
          
          <div className="space-y-4 text-slate-300">
            <p>
              가이드라인을 위반하는 사용자를 발견하면 신고해 주세요. 
              여러분의 신고가 건전한 커뮤니티를 만드는 데 큰 도움이 됩니다.
            </p>
            
            <div className="bg-slate-700/50 rounded-lg p-4">
              <h4 className="font-medium mb-2">신고 방법:</h4>
              <ol className="list-decimal list-inside space-y-1 text-sm text-slate-400">
                <li>게임 중 또는 결과 화면에서 신고 버튼을 클릭</li>
                <li>신고 사유 선택 (욕설, 혐오 발언, 성희롱, 게임 방해 등)</li>
                <li>추가 설명 입력 (선택)</li>
                <li>신고 제출</li>
              </ol>
            </div>
            
            <p className="text-sm text-slate-400">
              신고된 내용은 운영팀에서 검토 후 적절한 조치를 취합니다. 
              허위 신고를 반복하는 경우 신고자도 제재를 받을 수 있습니다.
            </p>
          </div>
        </section>

        {/* Appeal */}
        <section className="bg-slate-800/50 rounded-2xl p-6 mb-6">
          <h3 className="text-xl font-semibold mb-4">📝 이의 신청</h3>
          
          <p className="text-slate-300 mb-4">
            제재 조치에 이의가 있는 경우, 문의하기를 통해 소명할 수 있습니다.
            소명 내용을 검토한 후 제재가 부당하다고 판단되면 조치가 철회될 수 있습니다.
          </p>
          
          <button
            onClick={() => navigate('/about')}
            className="btn-primary px-6 py-2 rounded-lg"
          >
            문의하기
          </button>
        </section>

        {/* Agreement */}
        <section className="bg-primary-900/20 border border-primary-700/50 rounded-2xl p-6 text-center">
          <p className="text-slate-300">
            말싸움 서비스를 이용하시면 본 커뮤니티 가이드라인에 동의하는 것으로 간주됩니다.
            <br />
            <span className="text-slate-400 text-sm">
              가이드라인은 서비스 운영 상황에 따라 변경될 수 있으며, 변경 시 공지합니다.
            </span>
          </p>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-slate-700 py-8 px-4 mt-8">
        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400 mb-4">
            <button onClick={() => navigate('/')} className="hover:text-white transition-colors">
              홈
            </button>
            <button onClick={() => navigate('/about')} className="hover:text-white transition-colors">
              서비스 소개
            </button>
            <button onClick={() => navigate('/faq')} className="hover:text-white transition-colors">
              자주 묻는 질문
            </button>
          </div>
          <p className="text-center text-slate-500 text-xs">
            © 2024 말싸움. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
